<template>
  <component :is="screen"></component>
</template>

<script>
import LoadingLayout from './LoadingLayout.vue'

export default {
  computed: {
    screen() {
      if (this.$store.getters['app/isGuestRoute']) {
        return 'guest-layout'
      }

      if (this.$store.getters['auth/isAuthenticated']) {
        if (
          this.$store.getters['auth/hasInactiveProfile'] &&
          !this.$store.getters['auth/isStaff']
        ) {
          return 'profiles-layout'
        }
        return 'user-layout'
      }

      return 'loading-layout'
    },
  },
  components: {
    GuestLayout: () => import(/* webpackChunkName: "guestLayout" */ './GuestLayout'),
    UserLayout: () => import(/* webpackChunkName: "userLayout" */ './UserLayout'),
    ProfilesLayout: () => import(/* webpackChunkName: "profilesLayout" */ './ProfilesLayout'),
    LoadingLayout,
  },
}
</script>
